export function trackEvent(name: string, params?: Record<string, string>) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}
